// eslint-disable-next-line import/no-extraneous-dependencies
import * as RadixDropdown from "@radix-ui/react-dropdown-menu";
import { styled } from "@vitality-ds/system";
import BaseItemStyles from "../DropdownMenuItem/styles/BaseItem.styles";
import BaseCheckableItemStyles from "./styles/BaseCheckableItem.styles";
export var BaseCheckableItem = styled(RadixDropdown.CheckboxItem, BaseItemStyles, BaseCheckableItemStyles);
var CheckedIndicator = RadixDropdown.ItemIndicator;
export { CheckedIndicator };